import { create } from 'zustand'
import { DissmisedRecommendationsStore } from '../types/recommendations'

export const useDissmissedRecommendationsStore =
  create<DissmisedRecommendationsStore>((set) => ({
    dismissedRecommendations: [],
    dismissRecommendation: (recommendationId) =>
      set((state) => ({
        dismissedRecommendations: [
          ...state.dismissedRecommendations,
          recommendationId,
        ],
      })),
  }))
